<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16mTFrn/tc-custom/9780814724118.jpg?1719926996355" alt="This image is the cover for the book Forging Napoleon's Grande Armée, Warfare and Culture"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Forging Napoleon's Grande Armée, Warfare and Culture
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“A fascinating study exploring the motivation of French soldiers during the Napoleonic Era, and the process through which they became Napoleon’s men.”—Frederick C. Schneid, author of <i>Napoleon’s Conquest of Europe</i></b><br/>  <br/> The men who fought in Napoleon’s Grande Armée built a new empire that changed the world. Remarkably, the same men raised arms during the French Revolution for liberté, égalité, and fraternité. In just over a decade, these freedom fighters, who had once struggled to overthrow tyrants, rallied to the side of a man who wanted to dominate Europe. What was behind this drastic change of heart?<br/><br/> In this ground-breaking study, Michael J. Hughes shows how Napoleonic military culture shaped the motivation of Napoleon’s soldiers. Relying on extensive archival research and blending cultural and military history, Hughes demonstrates that the Napoleonic regime incorporated elements from both the Old Regime and French Revolutionary military culture to craft a new military culture, characterized by loyalty to both Napoleon and the preservation of French hegemony in Europe. Underscoring this new, hybrid military culture were five sources of motivation: honor, patriotism, a martial and virile masculinity, devotion to Napoleon, and coercion. <i>Forging Napoleon’s Grande Armée</i> vividly illustrates how this many-pronged culture gave Napoleon’s soldiers reasons to fight.<br/>  <br/><b>“Hughes offers a tight and well-grounded exposition and analysis of French military culture in the Napoleonic period in which military honour is presented as a dynamic element.” —<i>Journal of European Studies</i></b><br/>  <br/><b>“Hughes’s book not only contributes to our understanding of the military success of Napoleon’s army, but also elegantly employs cultural history methods to better understand army operations and sustained troop motivations.” —Julia Osman, <i>History: Reviews of New Book</i></b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael J Hughes
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New York University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8255a26c